import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { ArrowDownToLine, ArrowUpToLine, Pencil } from "lucide-react";
import { MdCancel } from "react-icons/md";

import css from "../../../dishesSection/dishesSectionModals/DishProductModal/DishProductModal.module.css";
import { semiFinishedProductsActions } from "../../../../store/slices/semiFinished-slice";
import { SemiFinishedUpdateProductModal } from "../SemiFinishedAddProductModal/SemiFinishedUpdateProductModal";


const SemiFinishedProductModal = ({ semiFinishedProduct, index }) => {
    const dispatch = useDispatch();

    const { id, name, weight, cost, weightNetto, product } = semiFinishedProduct;

    const { semiFinishedProductsForModalArray } = useSelector(store => store.semiFinishedProducts);

    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const productName = product?.product?.name || product?.name || name;
    const displayName = productName?.[currentLanguage] || productName?.['en'] || 'Unknown Product';

    // Nutrients: manually added items store them in product.{energy,fats,...}
    // API items store them in product.product.{energy,fats,...}
    const energy = product?.energy ?? product?.product?.energy ?? 0;
    const proteins = product?.proteins ?? product?.product?.proteins ?? 0;
    const fats = product?.fats ?? product?.product?.fats ?? 0;
    const carbohydrates = product?.carbohydrates ?? product?.product?.carbohydrates ?? 0;

    const [isOpenUpdate, setIsOpenUpdate] = useState(false);

    const deleteSemiFinishedProduct = () => {
        dispatch(semiFinishedProductsActions.removeDishProductForModal(id));
    };

    const handleUpClick = () => {
        if (index === 0) return;
        const newArray = [...semiFinishedProductsForModalArray];
        newArray.splice(index, 1);
        newArray.splice(index - 1, 0, semiFinishedProductsForModalArray[index]);
        dispatch(semiFinishedProductsActions.updateSemiFinishedProductsForModal(newArray));
    };

    const handleDownClick = () => {
        if (index === semiFinishedProductsForModalArray.length - 1) return;
        const newArray = [...semiFinishedProductsForModalArray];
        newArray.splice(index, 1);
        newArray.splice(index + 1, 0, semiFinishedProductsForModalArray[index]);
        dispatch(semiFinishedProductsActions.updateSemiFinishedProductsForModal(newArray));
    };

    return (
        <section className={css.wrap}>
            <div className={css.product}>
                {displayName}

                <div className={css.nutritionGrid}>
                    <div className={css.nutritionItem}>
                        <span className={css.nutritionLabel}>E:</span>
                        <span className={css.nutritionValue}>{energy || 0} kcal</span>
                    </div>
                    <div className={css.nutritionItem}>
                        <span className={css.nutritionLabel}>P:</span>
                        <span className={css.nutritionValue}>{proteins || 0} g</span>
                    </div>
                    <div className={css.nutritionItem}>
                        <span className={css.nutritionLabel}>F:</span>
                        <span className={css.nutritionValue}>{fats || 0} g</span>
                    </div>
                    <div className={css.nutritionItem}>
                        <span className={css.nutritionLabel}>C:</span>
                        <span className={css.nutritionValue}>{carbohydrates || 0} g</span>
                    </div>
                </div>
            </div>
            <div className={css.weight}>{weight}</div>
            <div className={css.weightNetto}>{weightNetto}</div>
            <div className={css.price}>{cost}</div>
            <div className={css.index}>
                {index > 0 && <ArrowUpToLine size={16} onClick={handleUpClick} />}
                {index !== semiFinishedProductsForModalArray.length - 1 && (
                    <ArrowDownToLine size={16} onClick={handleDownClick} />
                )}
            </div>
            <div className={css.actions}>
                <div className={css.updateButton} onClick={() => setIsOpenUpdate(true)}>
                    <Pencil size={16} />
                </div>
                <div className={css.deleteButton} onClick={deleteSemiFinishedProduct}>
                    <MdCancel size={16} />
                </div>
            </div>

            {isOpenUpdate && (
                <SemiFinishedUpdateProductModal
                    productId={semiFinishedProduct.productId ?? id}
                    setProductUpdateOpen={setIsOpenUpdate}
                    weight={weight}
                    weightNetto={weightNetto}
                />
            )}
        </section>
    );
};

export default React.memo(SemiFinishedProductModal);
